import React from 'react'

class CalculatorAssumptionBox extends React.Component {
  render() {
    return (
      <div className='calculator-assumption-box__overlay'>
        <div className="calculator-assumption-box">
          <h2 className="calculator-assumption-box__header">Assumptions</h2>
          <div className="calculator-assumption-box__contents">
            {this.props.children}
          </div>
          <button className="calculator-assumption-box__dismiss" onClick={this.props.handleDismiss}/>
        </div>
      </div>
    )
  }
}

export default CalculatorAssumptionBox;
